/**
 * Filled by data from API call
 * /umbraco/delivery/api/v2/content?filter=contentType:summaryTranslationItem
 */
export default class SummaryTranslationItem {
    fetchKey: string;
    iconUrl: string | null;
    text0: string | null;
    text1: string | null;
    textM: string | null;

    constructor(fetchKey: string, iconUrl: string | null, text0: string | null, text1: string | null, textM: string | null) {
        this.fetchKey = fetchKey;
        this.iconUrl = iconUrl;
        this.text0 = text0;
        this.text1 = text1;
        this.textM = textM;
    }
}

export interface SummaryTranslationItemProperties {
    summaryTranslationItem: SummaryTranslationItem | undefined;
}